import type { RouteObject } from "react-router";
import { DefaultPlaybookGate } from "../../features/links/defaultPlaybookRedirect.js";
import { appPaths } from "../appPaths.js";
import { defineHandle } from "../navigation/appRouteHandle.js";

/**
 * Wraps every playbook-scoped subtree in the shared `:playbookId` parent that
 * resolves default-playbook placeholder URLs (see {@link DefaultPlaybookGate})
 * before any of them render. Both route trees have playbook-scoped routes, so
 * both wrap them in this route.
 *
 * `children` keep their absolute `appPaths` patterns, which React Router allows
 * for child routes that start with their parent's path.
 */
export function createPlaybookRoute(children: RouteObject[]): RouteObject {
  return {
    path: appPaths.playbook.pattern,
    Component: DefaultPlaybookGate,
    // The fallback page context for every playbook-scoped page; deeper routes
    // with their own descriptor (the teammate page) win.
    handle: defineHandle({
      pageContext: ({ params }) => ({
        page: "playbook",
        playbookId: params.playbookId,
      }),
    }),
    children,
  };
}
